import React from 'react';
import { Box, Stack, SxProps, Theme } from '@mui/material';
import { TextBone } from '../../atoms/TextBone/TextBone';
import { FieldGroupBone } from '../../molecules/FieldGroupBone/FieldGroupBone';
import { StatusGroupBone } from '../../molecules/StatusGroupBone/StatusGroupBone';
import { ActionGroupBone } from '../../molecules/ActionGroupBone/ActionGroupBone';

interface DataCardBoneProps {
    /** Afficher l'en-tête */
    showHeader?: boolean;
    /** Afficher les contrôles */
    showControls?: boolean;
    /** Nombre de lignes de données */
    dataLines?: number;
    /** Nombre de statuts */
    statusCount?: number;
    /** Nombre d'actions */
    actionCount?: number;
    /** Styles personnalisés */
    sx?: SxProps<Theme>;
}

export const DataCardBone: React.FunctionComponent<DataCardBoneProps> = function ({
    showHeader = false,
    showControls = false,
    dataLines = 4,
    statusCount = 3,
    actionCount = 2,
    sx = {},
}) {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'flex-start',
                justifyContent: 'space-between',
                width: '100%',
                height: showHeader ? '200px' : '130px',
                ...sx,
            }}
        >
            <Stack
                sx={{
                    flex: 1,
                    gap: 0,
                }}
            >
                {showHeader && <TextBone sx={{ width: '40%', height: '60px' }} />}
                {Array.from({ length: dataLines }).map((_, index) => (
                    <FieldGroupBone
                        key={`data-line-${dataLines}-${index + 1}`}
                        labelWidth="20%"
                        contentWidth="40%"
                        labelHeight="32px"
                        contentHeight="28px"
                        direction="row"
                    />
                ))}
            </Stack>

            <Stack
                sx={{
                    alignItems: 'flex-end',
                    justifyContent: 'space-between',
                    width: '20%',
                    height: '95%',
                    gap: 1,
                }}
            >
                <StatusGroupBone
                    count={statusCount}
                    statusSize="30px"
                    direction="row"
                />
                {showControls && (
                    <ActionGroupBone
                        count={actionCount}
                        actionWidth="100px"
                        actionHeight="30px"
                        direction="row"
                    />
                )}
            </Stack>
        </Box>
    );
};
